const PLYR_DEFAULTS = {
  hideControls: true,
  settings: ['captions'],
  invertTime: false,
  storage: { enabled: false },
  controls: [
    'play-large', // The large play button in the center
    'play', // Play/pause playback
    'progress', // The progress bar and scrubber for playback and buffering
    'current-time', // The current time of playback
    'mute', // Toggle mute
    'volume', // Volume control
    // 'captions', // Toggle captions
    'fullscreen', // Toggle fullscreen
  ],
};

export class PlyrPlayer {
  constructor(api, target, options = {}) {
    this.Api = api;
    this.target = target;
    this.audioOptions = options;
    this.videoOptions = PLYR_DEFAULTS;
    this.player = null;
  }

  create = () => {
    const isAudio = this.target.classList.contains('plyr-audio');
    if (isAudio) {
      this.player = new this.Api(this.target, this.audioOptions);
    } else {
      this.player = new this.Api(this.target, this.videoOptions);
    }
    return this.player;
  };
}

export const getPlyr = async () => {
  const _ = await import(/* webpackChunkName: 'plyr' */ 'plyr');
  return _.default;
};
